"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricType = void 0;
exports.MetricType = {
    Credits: "credits",
    MinutesUsed: "minutes_used",
    RequestCount: "request_count",
    TtfbAvg: "ttfb_avg",
    TtfbP95: "ttfb_p95",
    FiatUnitsSpent: "fiat_units_spent",
    Concurrency: "concurrency",
};
